export const SEARCH_HISTORY_PREFIX: string = 'ocdb_';
